import { render, staticRenderFns } from "./institution.vue?vue&type=template&id=f4a25268&scoped=true&"
import script from "./institution.vue?vue&type=script&lang=ts&"
export * from "./institution.vue?vue&type=script&lang=ts&"
import style0 from "./institution.vue?vue&type=style&index=0&id=f4a25268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a25268",
  null
  
)

export default component.exports